// @flow
import React from 'react';
import { fromJS } from 'immutable';
import MitreAttackDefinitions from './mitre_attack_tactics_techniques.json';

// $FlowFixMe: need to upgrade flow defs
const MitreAttackThreatModelContext = React.createContext(fromJS(MitreAttackDefinitions));

export { MitreAttackThreatModelContext};


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/contexts/mitre-attack/context.js